// import Ads from '@shared/components/ads'
import Head from 'next/head'
import { useState } from 'react'
// import { isBrowser, isMobile, isTablet, isDesktop, isSmartTV, isAndroid, isIOS, browserName, getUA, deviceType, isWindows, isMacOs, deviceDetect } from 'react-device-detect'

const boxStyles = { padding: '12px', border: '1px solid #eaeaea', borderRadius: '10px' }
export default function Home() {
  const [count, setCount] = useState(0)
  if (count === 1) {
    throw new Error('I crashed!')
  }
  return (
    <div>
      <Head>
        <meta name="robots" content="noindex" />
        <meta name="robots" content="nofollow" />
        <script
          async
          id="AV65cb30ec27e7f3c72a07999a"
          type="text/javascript"
          src="https://tg1.aniview.com/api/adserver/spt?AV_TAGID=65cb30ec27e7f3c72a07999a&AV_PUBLISHERID=6215f6d82b93b72d275027d7"
        ></script>
      </Head>
      <main
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <p>{count} Get started by sending us a sample error</p>
        <button
          type="button"
          style={{
            ...boxStyles,
            backgroundColor: '#c73852',
            borderRadius: '12px',
            border: 'none'
          }}
          onClick={() => {
            setCount(count + 1)
          }}
        >
          Throw error
        </button>

        <p>
          For more information, see{' '}
          <a href="https://docs.sentry.io/platforms/javascript/guides/nextjs/">
            https://docs.sentry.io/platforms/javascript/guides/nextjs/
          </a>
        </p>
      </main>
    </div>
  )
}
export async function getServerSideProps({ req, res, params, query, resolvedUrl }) {
  res.setHeader('Cache-Control', 'public, max-age=420')
  return {
    props: {}
  }
}
